<div class="wrapper">
        <app-menu></app-menu>
        <div class="main-content">
            
            <router-outlet></router-outlet>
            
        </div>
</div>

<div class="support-panel" *ngIf="supportOpen">
    <div class="support-panel-header d-flex justify-content-between align-items-center px-3 py-2">
        <span><i class="fa fa-headphones me-2" aria-hidden="true"></i>Support</span>
        <button type="button" class="support-close" aria-label="Fermer" (click)="closeSupport()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="support-panel-body">
        <a class="support-link" routerLink="/admin/inqueries/index/new" (click)="closeSupport()">
            <i class="fa fa-plus-circle me-2" aria-hidden="true"></i>Signaler une preoccupation
        </a>
        <a class="support-link" routerLink="/admin/inqueries/index/own" (click)="closeSupport()">
            <i class="fa fa-list me-2" aria-hidden="true"></i>Mes requetes
        </a>
        <a class="support-link" routerLink="/admin/inqueries/index/pending" (click)="closeSupport()">
            <i class="fa fa-clock-o me-2" aria-hidden="true"></i>Preoccupations a resoudre
        </a>
    </div>
</div>

<button type="button" class="support-action" (click)="toggleSupport()"
        [attr.aria-expanded]="supportOpen" aria-label="Ouvrir le support">
    <span class="d-flex justify-content-between align-items-center px-3 py-2">
        <span>
            <i class="fa fa-headphones me-2" aria-hidden="true"></i>
            <span>Support</span>
        </span>
        <i class="fa" [class.fa-chevron-up]="!supportOpen" [class.fa-chevron-down]="supportOpen" aria-hidden="true"></i>
    </span>
</button>